import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/auth';

/**
 * Mirrors v1's `UserDefaultLanguageHandler`: once the clinician is loaded,
 * apply their saved `locale`. The `LanguageSwitcher` writes locale changes
 * back to the profile via PATCH, so the profile is the authoritative
 * source — no need for a local-preference workaround.
 *
 * `?lang=` still wins, matching v1.
 */
export const useUserDefaultLanguage = () => {
  const { i18n } = useTranslation();
  const clinician = useAuthStore((s) => s.clinician);
  useEffect(() => {
    if (!clinician) return;
    if (typeof window === 'undefined') return;
    const urlLang = new URL(window.location.href).searchParams.get('lang');
    if (urlLang) {
      if (i18n.language !== urlLang) i18n.changeLanguage(urlLang);
      return;
    }
    const target = (clinician.locale as string | undefined) || 'en';
    if (i18n.language !== target) i18n.changeLanguage(target);
  }, [clinician, i18n]);
};
